export default {
  GET_MONTH_SCHEDULE: 'GET_MONTH_SCHEDULE',
  GET_MONTH_SCHEDULE_ERROR: 'GET_MONTH_SCHEDULE_ERROR',
  START_FETCHING_MONTH: 'START_FETCHING_MONTH',
  STOP_FETCHING_MONTH: 'STOP_FETCHING_MONTH',

  GET_DAY_EVENT: 'GET_DAY_EVENT',
  GET_DAY_EVENT_ERROR: 'GET_DAY_EVENT_ERROR',
  START_FETCHING_DAY: 'START_FETCHING_DAY',
  STOP_FETCHING_DAY: 'STOP_FETCHING_DAY',

  RESET_SCHEDULE: 'RESET_SCHEDULE',
};
